const en = {
  // Common
  save: "Save",
  cancel: "Cancel",
  delete: "Delete",
  edit: "Edit",
  search: "Search",
  loading: "Loading...",
  noData: "No data",
  download: "Download",
  upload: "Upload",
  back: "Back",
  close: "Close",
  confirm: "Confirm",
  create: "Create",
  view: "View",
  all: "All",
  active: "Active",
  archived: "Archived",
  draft: "Draft",
  published: "Published",

  // Auth
  login: "Login",
  logout: "Logout",
  loginWithGoogle: "Continue with Google",
  email: "Email",
  password: "Password",
  forgotPassword: "Forgot password?",

  // Navigation - Learner
  nav_home: "Home",
  nav_sequences: "E-learning sequences",
  nav_progress: "Pedagogical progress",
  nav_program: "Program",
  nav_learners: "Learners",
  nav_attendance: "Attendance",
  nav_evaluations: "Evaluations",
  nav_documents: "Documents",
  nav_certificates: "Certificates",
  nav_badges: "Badges & XP",
  nav_about: "About",
  nav_sessions: "Your sessions:",
  nav_selectSession: "Select a session",
  nav_learnerSpace: "Learner space",

  // Navigation - Admin
  nav_dashboard: "Dashboard",
  nav_agenda: "Agenda",
  nav_commercial: "Commercial",
  nav_salesFunnel: "Sales funnel",
  nav_registrations: "Registrations",
  nav_trainingSessions: "Training sessions",
  nav_allSessions: "All sessions",
  nav_archivedSessions: "Archived sessions",
  nav_elearning: "E-learning",
  nav_elearningDashboard: "E-learning dashboard",
  nav_courses: "Courses",
  nav_sequencesAdmin: "Sequences",
  nav_activities: "Activities",
  nav_scorm: "SCORM Modules",
  nav_aiQuiz: "AI Quiz",
  nav_library: "Library",
  nav_programs: "Programs",
  nav_evalsAdmin: "Evaluations",
  nav_archives: "Archives",
  nav_reports: "Reports",
  nav_activityReport: "Activity tracking",
  nav_invoices: "Invoice tracking",
  nav_commercialReport: "Commercial tracking",
  nav_bpf: "Pedagogical report",
  nav_quality: "Quality tracking",
  nav_improvement: "Continuous improvement",
  nav_marketplace: "Marketplace",
  nav_data: "Data",
  nav_companies: "Companies",
  nav_students: "Learners",
  nav_trainers: "Trainers",
  nav_funders: "Funders",
  nav_locations: "Locations",
  nav_settings: "Settings",

  // Dashboard - Learner
  dash_sessionTitle: "Training session",
  dash_elearning: "E-learning",
  dash_progressLabel: "progress",
  dash_accessElearning: "Access e-learning",
  dash_attendance: "Attendance",
  dash_pendingSignatures: "pending signature(s)",
  dash_noPending: "No pending attendance",
  dash_sign: "Sign",
  dash_rules: "Internal rules",
  dash_trainers: "Your trainers",
  dash_discoverTrainers: "Discover your trainers",
  dash_calendar: "Calendar",
  dash_trainingSlots: "Your training slots",
  dash_nextSlot: "Next slot",
  dash_today: "Today",

  // Gamification
  gam_level: "Level",
  gam_xpTotal: "total XP",
  gam_badgesEarned: "badges earned",
  gam_progressToNext: "Progress to level",
  gam_badges: "Badges",
  gam_leaderboard: "Leaderboard",
  gam_leaderboardTitle: "Learners leaderboard",
  gam_noLeaderboard: "No leaderboard available",
  gam_you: "(you)",
  gam_viewAll: "View all",
  gam_earnXP: "Earn XP points and unlock badges",
  gam_myBadges: "My badges & progress",

  // Certificates
  cert_title: "My certificates",
  cert_subtitle: "Your training certificates",
  cert_generate: "Get certificate",
  cert_download: "Download PDF",
  cert_sendEmail: "Send by email",
  cert_generated: "Certificate generated! An email with the PDF has been sent.",
  cert_resent: "Certificate resent by email!",
  cert_eligible: "Eligible",
  cert_notEligible: "Not eligible",

  // Documents
  doc_title: "Documents",
  doc_subtitle: "Session documents:",
  doc_uploadBtn: "Upload a document",
  doc_uploading: "Uploading...",
  doc_dragDrop: "Drag & drop or click to upload a file",
  doc_formats: "PDF, Word, Excel, Images - Max 50 MB",
  doc_platform: "Platform documents",
  doc_uploaded: "Uploaded files",
  doc_total: "Total",
  doc_noDocuments: "No documents",
  doc_noDocDesc: "Upload a document or wait for your trainer to share one",

  // Settings
  settings_title: "Settings",
  settings_subtitle: "Configure your training platform",
  settings_organism: "Organization",
  settings_email: "Email",
  settings_theme: "Theme",
  settings_security: "Security",
  settings_orgName: "Organization name",
  settings_orgFull: "Full name",
  settings_emailContact: "Contact email",
  settings_phone: "Phone",
  settings_address: "Address",
  settings_saved: "Settings saved",

  // Reports
  reports_activity: "Activity tracking",
  reports_activityDesc: "Overview of training activity",
  reports_formations: "Courses",
  reports_students: "Learners",
  reports_sessions: "Sessions",
  reports_certificates: "Certificates",
  reports_completionRate: "Completion rate by course",
  reports_keyIndicators: "Key indicators",
  reports_overview: "Overview",
  reports_exports: "Available exports",
  reports_attendanceRate: "Attendance rate",
  reports_evalCompleted: "Evaluations completed",
  reports_activeEnrollments: "Active enrollments",
  reports_availableDocs: "Available documents",

  // About
  about_title: "About",
  about_subtitle: "Information about your training organization",
  about_mission: "Our mission",
  about_missionText: "AFFEA supports education and training professionals in developing their pedagogical skills.",
  about_qualiopi: "Qualiopi Certification",
  about_qualiopiDesc: "Certified organization, ensuring the quality of our training processes",
  about_accessibility: "Accessibility",
  about_accessibilityDesc: "Committed to making our training accessible to all",
  about_contact: "Contact us",
  about_handicap: "Disability advisor",

  // AFFEA Accessibility content
  affea_commitment: "is committed to making its training accessible",
  affea_measure: "We regularly measure the accessibility level of our training and commit to concrete improvement actions.",
  affea_engagements: "Our commitments:",
  affea_eng1: "Improve our disability questionnaire to be more specific regarding RQTH",
  affea_eng2: "Organize positioning phone interviews to adapt our intervention upstream",
  affea_eng3: "Organize accommodations to improve session accessibility for people with disabilities",
  affea_progress: "Our areas for improvement:",
  affea_prog1: "Improve our welcoming and support approach for learners with disabilities",
  affea_prog2: "Make all our information and educational content accessible to everyone",
  affea_prog3: "Better identify learners with disabilities well before the start of training",
  affea_questions: "Questions?",
  affea_contactRef: "Contact our disability advisor:",

  // Login
  login_welcome: "Welcome",
  login_subtitle: "Log in to access your training and track your progress.",
  login_demo: "Demo access",
  login_learner: "Learner",
  login_trainer: "Trainer",
  login_admin: "Admin",
  login_terms: "By logging in, you agree to our",
  login_termsLink: "terms of service",
  login_privacyLink: "privacy policy",

  // Misc
  languageToggle: "Switch language",
  notifications: "Notifications",
  markAllRead: "Mark all read",
  noNotifications: "No notifications",
};

export default en;
